import { ReactElement } from 'react';
import MtIcon, { IIconComponentProps } from 'mt-web-icons/react/Icon/cjs';

import './style.scss';

export interface IProps extends IIconComponentProps {
  icon: string;

  'data-testid'?: string;
}

export default function Icon({
  className = '',
  ...props
}: IProps): ReactElement {
  // The react types up until react 18 don't handle ReactNode correctly, which fails
  // typechecks, while the code runs just fine. This is a workaround to avoid the typecheck.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <MtIcon {...props} role="img" className={`icon ${className}`} />;
}
